import { render } from "./SubjectList.vue?vue&type=template&id=53446a64"
import script from "./SubjectList.vue?vue&type=script&lang=js"
export * from "./SubjectList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__